import React from 'react'

import { PaginatedTable, PaginatedTableCallbacks } from '../../common'
import { SupplierBrandsTable } from './collectionTable'
import { JsonSupplierBrand, SupplierBrand } from '../../../models'
import { getSupplierBrands } from '../../../api'
import { getAuthUser } from '../../../helpers';
import defineAbilityFor from './defineAbility'
import { InsufficientPermissions } from '../../common';

export const SupplierBrandsLanding = () => {
    const ability = defineAbilityFor(getAuthUser())

    if (!ability.can('View', 'SupplierBrand')) {
        return <InsufficientPermissions />
    }

    return (
        <PaginatedTable<SupplierBrand, JsonSupplierBrand>
            getData={getSupplierBrands}
            redirectLink={{
                to: '/suppliers/brands/add',
                text: 'Create New Brand'
            }}
            modelConstructor={(json: JsonSupplierBrand) => new SupplierBrand(json)}
            searchPlaceholder='Search by Name or Id'
            Table={(supplierBrands: SupplierBrand[], callbacks: PaginatedTableCallbacks) => (
                <SupplierBrandsTable
                    callbacks={callbacks}
                    resources={{ supplierBrands }} />
            )}
            title='Supplier Brands' />
    )
}
